module.exports = __webpack_public_path__ + "static/img/agrinome_logo.68aa710.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/agrinome_logo/agrinome_logo.jpg
// module id = 2lAA
// module chunks = 102